<template>
    <div class="mt-3">
        <b-alert variant="warning" show class="mb-0">
            <h5 class="alert-heading">
                <font-awesome-icon icon="fa-duotone fa-shield-check" class="mr-1" />
                {{ $t("Temporary Card Limitation") }}
            </h5>
            <p class="mb-0">
                {{
                    $t(
                        "Your card has declined multiple times in a row. Due to payment network regulations, we are required to temporarily limit card purchases after repeated declines."
                    )
                }}
            </p>
        </b-alert>

        <div class="mt-3">
            <h6>{{ $t("Current Limitations") }}</h6>
            <b-list-group>
                <b-list-group-item
                    class="d-flex align-items-center justify-content-between"
                >
                    {{ $t("Minimum purchase amount") }}
                    <b-badge variant="light" pill>
                        ${{ cardLimited.minimumAmount }}
                    </b-badge>
                </b-list-group-item>
                <b-list-group-item
                    class="d-flex align-items-center justify-content-between"
                >
                    {{ $t("Remaining attempts today") }}
                    <b-badge variant="light" pill>
                        {{ cardLimited.remainingTransactions }}
                        {{ $t("of") }}
                        {{ cardLimited.maxTransactionsPerDay }}
                    </b-badge>
                </b-list-group-item>
            </b-list-group>
        </div>

        <div class="mt-3">
            <small class="text-muted">
                {{
                    $t(
                        "This limitation is automatically lifted after a few successful transactions. No action is required on your part beyond completing your next purchases normally."
                    )
                }}
            </small>
        </div>

        <b-btn
            @click="dismiss"
            variant="primary"
            block
            pill
            size="lg"
            class="mt-3"
        >
            {{ $t("Continue") }}
        </b-btn>
    </div>
</template>

<script>
import { mapState } from "vuex";

export default {
    computed: {
        ...mapState({
            cardLimited: (state) => state.onboarding.user.cardLimited,
        }),
    },
    methods: {
        dismiss() {
            this.$store.commit("wallet/setCardLimitedDismissed", true);
        },
    },
};
</script>
